import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    fuelTanks: {
        value: [],
        config: {
            id: {},
            type: {},
            fuelConsumption: {
                // field
                label: "Расход топлива, л/100км",
                inputProps: { name: "fuelConsumption", type: "number", min: 0 },
                required: true,
                validators: [requiredField],
            },
            minimumVolume: {
                // field
                label: "Минимальное кол-во топлива в баке",
                inputProps: { name: "minimumVolume", type: "number", min: 0 },
                required: true,
                validators: [requiredField],
            },
            currentVolume: {
                // field
                label: "Текущий объем топлива",
                inputProps: { name: "currentVolume", type: "number", min: 0 },
                required: true,
                validators: [requiredField],
            },
            totalVolume: {
                // field
                label: "Объем бака",
                inputProps: { name: "totalVolume", type: "number", min: 0 },
                required: true,
                validators: [requiredField],
            },
            minimumVolumeInFinishDesired: {
                // field
                label: "Желаемый объем на выгрузке",
                inputProps: { name: "minimumVolumeInFinishDesired", type: "number", min: 0 },
            },
        },
    },
    bidId: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
